/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CoaAccountDTO,
  FeeDTO,
  GetAcAccountsForFeesParams,
  GetGlAccountsForFeesParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getFee = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FeeDTO>(
      {url: `/api/fees/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFeeInfiniteQueryKey = (id?: number,) => {
    return [
    'infinite', `/api/fees/${id}`
    ] as const;
    }

export const getGetFeeQueryKey = (id?: number,) => {
    return [
    `/api/fees/${id}`
    ] as const;
    }

    
export const getGetFeeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFee>>>, TError = unknown>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeeInfiniteQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFee>>> = ({ signal }) => getFee(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFee>>>
export type GetFeeInfiniteQueryError = unknown


export function useGetFeeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFee>>>, TError = unknown>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFee>>,
          TError,
          Awaited<ReturnType<typeof getFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFee>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFee>>,
          TError,
          Awaited<ReturnType<typeof getFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFeeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFee>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFeeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFee>>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeeInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFeeQueryOptions = <TData = Awaited<ReturnType<typeof getFee>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFee>>> = ({ signal }) => getFee(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFeeQueryResult = NonNullable<Awaited<ReturnType<typeof getFee>>>
export type GetFeeQueryError = unknown


export function useGetFee<TData = Awaited<ReturnType<typeof getFee>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFee>>,
          TError,
          Awaited<ReturnType<typeof getFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFee<TData = Awaited<ReturnType<typeof getFee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFee>>,
          TError,
          Awaited<ReturnType<typeof getFee>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFee<TData = Awaited<ReturnType<typeof getFee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetFee<TData = Awaited<ReturnType<typeof getFee>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFee>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFeeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const updateFee = (
    id: number,
    feeDTO: FeeDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FeeDTO>(
      {url: `/api/fees/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: feeDTO
    },
      options);
    }
  


export const getUpdateFeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFee>>, TError,{id: number;data: FeeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFee>>, TError,{id: number;data: FeeDTO}, TContext> => {

const mutationKey = ['updateFee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFee>>, {id: number;data: FeeDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFee(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFeeMutationResult = NonNullable<Awaited<ReturnType<typeof updateFee>>>
    export type UpdateFeeMutationBody = FeeDTO
    export type UpdateFeeMutationError = unknown

    export const useUpdateFee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFee>>, TError,{id: number;data: FeeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFee>>,
        TError,
        {id: number;data: FeeDTO},
        TContext
      > => {

      const mutationOptions = getUpdateFeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const deleteFee = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/fees/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteFeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFee>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFee>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteFee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFee>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteFee(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFee>>>
    
    export type DeleteFeeMutationError = unknown

    export const useDeleteFee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFee>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFee>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteFeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllFees = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FeeDTO[]>(
      {url: `/api/fees`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllFeesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/fees`
    ] as const;
    }

export const getGetAllFeesQueryKey = () => {
    return [
    `/api/fees`
    ] as const;
    }

    
export const getGetAllFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllFees>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFees>>> = ({ signal }) => getAllFees(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFees>>>
export type GetAllFeesInfiniteQueryError = unknown


export function useGetAllFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFees>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFees>>,
          TError,
          Awaited<ReturnType<typeof getAllFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFees>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFees>>,
          TError,
          Awaited<ReturnType<typeof getAllFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFees>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFees>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllFeesQueryOptions = <TData = Awaited<ReturnType<typeof getAllFees>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFees>>> = ({ signal }) => getAllFees(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFees>>>
export type GetAllFeesQueryError = unknown


export function useGetAllFees<TData = Awaited<ReturnType<typeof getAllFees>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFees>>,
          TError,
          Awaited<ReturnType<typeof getAllFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFees<TData = Awaited<ReturnType<typeof getAllFees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFees>>,
          TError,
          Awaited<ReturnType<typeof getAllFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFees<TData = Awaited<ReturnType<typeof getAllFees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFees<TData = Awaited<ReturnType<typeof getAllFees>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const createFee = (
    feeDTO: FeeDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FeeDTO>(
      {url: `/api/fees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeDTO, signal
    },
      options);
    }
  


export const getCreateFeeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: FeeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: FeeDTO}, TContext> => {

const mutationKey = ['createFee'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFee>>, {data: FeeDTO}> = (props) => {
          const {data} = props ?? {};

          return  createFee(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFeeMutationResult = NonNullable<Awaited<ReturnType<typeof createFee>>>
    export type CreateFeeMutationBody = FeeDTO
    export type CreateFeeMutationError = unknown

    export const useCreateFee = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFee>>, TError,{data: FeeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFee>>,
        TError,
        {data: FeeDTO},
        TContext
      > => {

      const mutationOptions = getCreateFeeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAllFeesByProductPropertiesGlNo = (
    glNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FeeDTO[]>(
      {url: `/api/fees/product-properties/${glNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllFeesByProductPropertiesGlNoInfiniteQueryKey = (glNo?: string,) => {
    return [
    'infinite', `/api/fees/product-properties/${glNo}`
    ] as const;
    }

export const getGetAllFeesByProductPropertiesGlNoQueryKey = (glNo?: string,) => {
    return [
    `/api/fees/product-properties/${glNo}`
    ] as const;
    }

    
export const getGetAllFeesByProductPropertiesGlNoInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeesByProductPropertiesGlNoInfiniteQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>> = ({ signal }) => getAllFeesByProductPropertiesGlNo(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeesByProductPropertiesGlNoInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>
export type GetAllFeesByProductPropertiesGlNoInfiniteQueryError = unknown


export function useGetAllFeesByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFeesByProductPropertiesGlNoInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeesByProductPropertiesGlNoInfiniteQueryOptions(glNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllFeesByProductPropertiesGlNoQueryOptions = <TData = Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError = unknown>(glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeesByProductPropertiesGlNoQueryKey(glNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>> = ({ signal }) => getAllFeesByProductPropertiesGlNo(glNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(glNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeesByProductPropertiesGlNoQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>>
export type GetAllFeesByProductPropertiesGlNoQueryError = unknown


export function useGetAllFeesByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>,
          TError,
          Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeesByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFeesByProductPropertiesGlNo<TData = Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError = unknown>(
 glNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeesByProductPropertiesGlNo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeesByProductPropertiesGlNoQueryOptions(glNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGlAccountsForFees = (
    params?: GetGlAccountsForFeesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaAccountDTO[]>(
      {url: `/api/fees/gl-accounts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetGlAccountsForFeesInfiniteQueryKey = (params?: GetGlAccountsForFeesParams,) => {
    return [
    'infinite', `/api/fees/gl-accounts`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetGlAccountsForFeesQueryKey = (params?: GetGlAccountsForFeesParams,) => {
    return [
    `/api/fees/gl-accounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetGlAccountsForFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getGlAccountsForFees>>>, TError = unknown>(params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlAccountsForFeesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlAccountsForFees>>> = ({ signal }) => getGlAccountsForFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGlAccountsForFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getGlAccountsForFees>>>
export type GetGlAccountsForFeesInfiniteQueryError = unknown


export function useGetGlAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGlAccountsForFees>>>, TError = unknown>(
 params: undefined |  GetGlAccountsForFeesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getGlAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGlAccountsForFees>>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getGlAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGlAccountsForFees>>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGlAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGlAccountsForFees>>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGlAccountsForFeesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetGlAccountsForFeesQueryOptions = <TData = Awaited<ReturnType<typeof getGlAccountsForFees>>, TError = unknown>(params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGlAccountsForFeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGlAccountsForFees>>> = ({ signal }) => getGlAccountsForFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGlAccountsForFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getGlAccountsForFees>>>
export type GetGlAccountsForFeesQueryError = unknown


export function useGetGlAccountsForFees<TData = Awaited<ReturnType<typeof getGlAccountsForFees>>, TError = unknown>(
 params: undefined |  GetGlAccountsForFeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getGlAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccountsForFees<TData = Awaited<ReturnType<typeof getGlAccountsForFees>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getGlAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGlAccountsForFees<TData = Awaited<ReturnType<typeof getGlAccountsForFees>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetGlAccountsForFees<TData = Awaited<ReturnType<typeof getGlAccountsForFees>>, TError = unknown>(
 params?: GetGlAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGlAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGlAccountsForFeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAllFeeCodes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string[]>(
      {url: `/api/fees/fee-codes`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllFeeCodesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/fees/fee-codes`
    ] as const;
    }

export const getGetAllFeeCodesQueryKey = () => {
    return [
    `/api/fees/fee-codes`
    ] as const;
    }

    
export const getGetAllFeeCodesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllFeeCodes>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeeCodesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFeeCodes>>> = ({ signal }) => getAllFeeCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeeCodesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFeeCodes>>>
export type GetAllFeeCodesInfiniteQueryError = unknown


export function useGetAllFeeCodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeeCodes>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeeCodes>>,
          TError,
          Awaited<ReturnType<typeof getAllFeeCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeeCodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeeCodes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeeCodes>>,
          TError,
          Awaited<ReturnType<typeof getAllFeeCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeeCodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeeCodes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFeeCodesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFeeCodes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeeCodesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllFeeCodesQueryOptions = <TData = Awaited<ReturnType<typeof getAllFeeCodes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFeeCodesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFeeCodes>>> = ({ signal }) => getAllFeeCodes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFeeCodesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFeeCodes>>>
export type GetAllFeeCodesQueryError = unknown


export function useGetAllFeeCodes<TData = Awaited<ReturnType<typeof getAllFeeCodes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeeCodes>>,
          TError,
          Awaited<ReturnType<typeof getAllFeeCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeeCodes<TData = Awaited<ReturnType<typeof getAllFeeCodes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFeeCodes>>,
          TError,
          Awaited<ReturnType<typeof getAllFeeCodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFeeCodes<TData = Awaited<ReturnType<typeof getAllFeeCodes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllFeeCodes<TData = Awaited<ReturnType<typeof getAllFeeCodes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFeeCodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFeeCodesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAcAccountsForFees = (
    params?: GetAcAccountsForFeesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CoaAccountDTO[]>(
      {url: `/api/fees/ac-accounts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAcAccountsForFeesInfiniteQueryKey = (params?: GetAcAccountsForFeesParams,) => {
    return [
    'infinite', `/api/fees/ac-accounts`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetAcAccountsForFeesQueryKey = (params?: GetAcAccountsForFeesParams,) => {
    return [
    `/api/fees/ac-accounts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAcAccountsForFeesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAcAccountsForFees>>>, TError = unknown>(params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAcAccountsForFeesInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcAccountsForFees>>> = ({ signal }) => getAcAccountsForFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAcAccountsForFeesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAcAccountsForFees>>>
export type GetAcAccountsForFeesInfiniteQueryError = unknown


export function useGetAcAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAcAccountsForFees>>>, TError = unknown>(
 params: undefined |  GetAcAccountsForFeesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getAcAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAcAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAcAccountsForFees>>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getAcAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAcAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAcAccountsForFees>>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAcAccountsForFeesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAcAccountsForFees>>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAcAccountsForFeesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAcAccountsForFeesQueryOptions = <TData = Awaited<ReturnType<typeof getAcAccountsForFees>>, TError = unknown>(params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAcAccountsForFeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcAccountsForFees>>> = ({ signal }) => getAcAccountsForFees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAcAccountsForFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getAcAccountsForFees>>>
export type GetAcAccountsForFeesQueryError = unknown


export function useGetAcAccountsForFees<TData = Awaited<ReturnType<typeof getAcAccountsForFees>>, TError = unknown>(
 params: undefined |  GetAcAccountsForFeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getAcAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAcAccountsForFees<TData = Awaited<ReturnType<typeof getAcAccountsForFees>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAcAccountsForFees>>,
          TError,
          Awaited<ReturnType<typeof getAcAccountsForFees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAcAccountsForFees<TData = Awaited<ReturnType<typeof getAcAccountsForFees>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAcAccountsForFees<TData = Awaited<ReturnType<typeof getAcAccountsForFees>>, TError = unknown>(
 params?: GetAcAccountsForFeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcAccountsForFees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAcAccountsForFeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




